import React from 'react';

const PaymentsView = ({ userEmail }) => {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-4xl mx-auto px-6 py-8">
        <h1 className="text-3xl font-black text-center mb-6">Payments</h1>
        <p className="text-slate-500 text-center">Payments tracking coming soon...</p>
      </div>
    </div>
  );
};

export default PaymentsView;